import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Loader } from '../../../../../../../common/react/components/Loader';

/**
 * @returns {JSX.Element} Loader or heading.
 */
export const BioStatItem = ( stat ) => {

    return (
        <div className='pp-bio-stats__stat-item'>
            <div className='pp-bio-stats__stat-name'>{stat.stat.name}</div>
            <div className='pp-bio-stats__stat-value'>{stat.stat.value}</div>
        </div>
    );
};

BioStatItem.propTypes = {
    stat: PropTypes.object.isRequired
};